import axios from "axios";
import { API_URL } from "../constant";

const API_BASE_URL = API_URL || "https://staging.api.topcoinuk.com/api";

const api = axios.create({
  baseURL: API_BASE_URL,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const accountClosureService = {
  // Get all closure requests with filters and pagination
  getClosureRequests: async (params = {}) => {
    const response = await api.get("/superadmin/account-closures", { params });
    return response.data;
  },

  // Get specific request details with live balance calculation
  getClosureRequestDetails: async (id) => {
    const response = await api.get(`/superadmin/account-closures/${id}`);
    return response.data;
  },

  // Approve a closure request
  approveRequest: async (id) => {
    const response = await api.post(`/superadmin/account-closures/${id}/approve`);
    return response.data;
  },

  // Reject a closure request
  rejectRequest: async (id, rejectionData) => {
    const response = await api.post(`/superadmin/account-closures/${id}/reject`, rejectionData);
    return response.data;
  },

  // Settle request (calculate & input settlement amount, method, reference)
  settleRequest: async (id, settlementData) => {
    const response = await api.post(`/superadmin/account-closures/${id}/settle`, settlementData);
    return response.data;
  },

  // Finalise account closure (sets status to PermanentClosure)
  finaliseRequest: async (id) => {
    const response = await api.post(`/superadmin/account-closures/${id}/finalise`);
    return response.data;
  },

  // Download Statement PDF
  downloadStatementPdf: async (id, filename = `TopCoin_Final_Statement_${id}.pdf`) => {
    const token = localStorage.getItem("auth_token");
    const response = await fetch(`${API_BASE_URL}/superadmin/account-closures/${id}/statement-pdf`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (!response.ok) {
      throw new Error("Failed to download PDF statement");
    }

    const blob = await response.blob();
    const downloadUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(downloadUrl);
  },
};

export default accountClosureService;
